module.exports = __webpack_public_path__ + "static/img/6.6ca7419.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/zh/6.png
// module id = wasL
// module chunks = 0